import React, {useCallback} from 'react';


import {Skeleton} from 'src/components/skeleton';
import {SwitcherLabel} from 'src/components/switcher-label';

import {FormSection} from '@pb/kit-component-form-section';
import StateButton from '@pb/kit-component-state-button';

import {AccountTeamMemberSettingsSkeleton} from './account-team-member-settings.skeleton';

import type {ChangeEventHandler, Dispatch, SetStateAction} from 'react';
import type {AccountManagerSettings} from 'src/openapi/admin/models/AccountManagerSettings';

type Props = {
    isLoading: boolean,
    accountTeamMemberSettings: AccountManagerSettings,
    setAccountTeamMemberSettings: Dispatch<SetStateAction<AccountManagerSettings>>,
    disabled?: boolean,
};

export const AccountTeamMemberSettings = (props: Props) => {
    const {isLoading, accountTeamMemberSettings, setAccountTeamMemberSettings, disabled} = props;

    const changeAccountTeamMemberState = useCallback<ChangeEventHandler<HTMLInputElement>>(event => {
        const accountManager = event.currentTarget.checked;
        setAccountTeamMemberSettings({accountManager});
    }, [setAccountTeamMemberSettings]);

    return (
        <Skeleton shown={isLoading} view={<AccountTeamMemberSettingsSkeleton/>}>
            <FormSection headline="Account Team Member Settings">
                <SwitcherLabel caption="Account Team Member" width={200}>
                    <StateButton
                        name="isAccountTeamMember"
                        disabled={disabled}
                        checked={accountTeamMemberSettings.accountManager}
                        onChange={changeAccountTeamMemberState}
                    />
                </SwitcherLabel>
            </FormSection>
        </Skeleton>
    );
};
